const state = {
  evidenceTypeMap: {
    1: '录音',
    2: '视频',
  }
}


export const userOrderStat = {
  state
}



// WEBPACK FOOTER //
// ./src/views/user-order-stat/userOrderStat.store.js